export enum SearchByType {
    // No Input Required
    STATIC_INPUT        = 1,
    // Text Based Input
    TEXT_INPUT          = 2,
    // Datepicker Input
    DATE_INPUT          = 3,
    // Dealer Autocomplete
    DEALER_INPUT        = 4
}